<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
body {
    margin: 0px;
    padding: 0px;
    height: 100%;
    background-color: #f3f4f7;
}
html,
body,
#app {
    height: 100%;
}
::-webkit-scrollbar {
    display: none;
}
.el-dialog__header {
    padding: 10px 10px 10px 15px !important;
    border-bottom: 1px solid #eeeeee;
}

.el-dialog__title {
    font-size: 14px !important;
    font-weight: bold;
}
.el-dialog__headerbtn {
    top: 15px !important;
}
.el-dialog__body {
    padding: 20px 20px 20px 20px !important;
}
.el-dialog__footer {
    padding: 10px !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4747ff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue